module.exports = __webpack_public_path__ + "img/Kspades.ed8ac724.jpg";